export const CHECK_ACCOUNT_BY_PHONE = 'CHECK_ACCOUNT_BY_PHONE';
export const CHECK_ACCOUNT_BY_PHONE_SUCCESS = 'CHECK_ACCOUNT_BY_PHONE_SUCCESS';
export const CHECK_ACCOUNT_BY_PHONE_ERROR = 'CHECK_ACCOUNT_BY_PHONE_ERROR';
export const CHECK_ACCOUNT_BY_PHONE_INITIAL = 'CHECK_ACCOUNT_BY_PHONE_INITIAL';

export interface CheckAccountByPhoneRequest {
    phone: string;
}

export interface CheckAccountByPhoneResponse {
    exists: boolean;
    verified: boolean;
    completed: boolean;
    tmLinked: boolean;
    signupToken?: string;
    userId?: string;
}

export interface CheckAccountByPhoneError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    status?: number;
}

export interface CheckAccountByPhoneState {
    data: CheckAccountByPhoneResponse | null;
    loading: boolean;
    error: CheckAccountByPhoneError | null;
}

export interface SetCheckAccountByPhoneInitialAction {
    type: typeof CHECK_ACCOUNT_BY_PHONE_INITIAL;
}

export interface CheckAccountByPhoneStartAction {
    type: typeof CHECK_ACCOUNT_BY_PHONE;
}

export interface CheckAccountByPhoneSuccessAction {
    type: typeof CHECK_ACCOUNT_BY_PHONE_SUCCESS;
    payload: CheckAccountByPhoneResponse;
}

export interface CheckAccountByPhoneErrorAction {
    type: typeof CHECK_ACCOUNT_BY_PHONE_ERROR;
    payload: CheckAccountByPhoneError;
}

export type CheckAccountByPhoneAction =
    | SetCheckAccountByPhoneInitialAction
    | CheckAccountByPhoneStartAction
    | CheckAccountByPhoneSuccessAction
    | CheckAccountByPhoneErrorAction;
